import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "ids"];
/* eslint-disable import/no-import-module-exports */
import { CustomPropTypes } from '@beef/react';
import { convertListToObjectBy } from '@beef/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { CurrentKeyProvider } from "./Provider";
import { mergeIds } from "./helpers";
import { composeCurrentKeySelector } from "./storage";
var generateCurrentKey = function generateCurrentKey() {
  return Symbol('Generated');
};
var selectRootState = function selectRootState(state) {
  return state;
};
var createMapperCurrentSelectors = function createMapperCurrentSelectors() {
  var selectDataList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var selectId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var KEY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : generateCurrentKey();
  var selectDataDict = createSelector(selectDataList, convertListToObjectBy(selectId));
  return {
    //   в любом случае требуется рефакторинг
    selectCurrent: createSelector([selectDataDict, composeCurrentKeySelector(KEY), selectRootState], function (dict, selectorOrKey, state) {
      return typeof selectorOrKey === 'function' ? selectorOrKey(state) : dict[selectorOrKey];
    }),
    // FIXME: Нужно отпрофилировать, посмотреть будут ли проблемы при такой динамике
    selectIds: createSelector(selectDataList, function (list) {
      return list.map(selectId);
    })
  };
};
var createProvider = function createProvider(KEY) {
  var CurrentProvider = function CurrentProvider(_ref) {
    var children = _ref.children,
      value = _ref.value;
    return /*#__PURE__*/React.createElement(CurrentKeyProvider, {
      name: KEY,
      value: value
    }, children);
  };
  CurrentProvider.propTypes = process.env.NODE_ENV !== "production" ? {
    children: PropTypes.node,
    /* eslint-disable-next-line react/forbid-prop-types */
    value: PropTypes.any
  } : {};
  return CurrentProvider;
};
var createMapperHOC = function createMapperHOC(CurrentProvider, selectIds) {
  return function (WrappedComponent) {
    var _CurrentMapper = function _CurrentMapper(_ref2) {
      var children = _ref2.children,
        ids = _ref2.ids,
        props = _objectWithoutProperties(_ref2, _excluded);
      return /*#__PURE__*/React.createElement(WrappedComponent, props, ids.map(function (id) {
        return /*#__PURE__*/React.createElement(CurrentProvider, {
          key: id,
          value: id
        }, children);
      }));
    };
    _CurrentMapper.propTypes = process.env.NODE_ENV !== "production" ? {
      children: PropTypes.node,
      ids: PropTypes.arrayOf(CustomPropTypes.id)
    } : {};
    return connect(function (state, ownProps) {
      return {
        // allow modifying ids by passing ownProps.ids {func|array}
        ids: mergeIds(selectIds(state), ownProps.ids)
      };
    }, {})(_CurrentMapper);
  };
};

/**
 * The private API might change in the future, without breaking change
 *   extend on your own risk
 * @private
 */
export var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = {
  createMapperCurrentSelectors: createMapperCurrentSelectors,
  createMapperHOC: createMapperHOC,
  createProvider: createProvider,
  generateCurrentKey: generateCurrentKey
};

// FIXME: Не получается найти способ применить изменения в этом файле
//   При обновлении генерируется новый ключ и происходит рассинхрон Provider'а и селекторов
//   Вероятно надо лечить на уровне CurrentKeyProvider'а
if (module.hot) {
  module.hot.decline();
}